"use client";
import React from "react";
import { Check } from "lucide-react";
import FadeUpText from "@/components/ui/FadeUp";

export const HeroSection: React.FC = () => {
  return (
    <section className="relative pt-20 pb-14 px-4 sm:px-6 text-center overflow-hidden">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] dark:bg-blue-600/8 bg-blue-400/8 rounded-full blur-3xl pointer-events-none" />

      <div className="relative z-10 max-w-[760px] mx-auto">
        <FadeUpText>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full dark:bg-blue-500/10 bg-blue-100 dark:border dark:border-blue-500/20 border border-blue-200 text-blue-800 dark:text-blue-300 text-sm font-semibold mb-8 tracking-widest uppercase">
            Pricing
          </div>
        </FadeUpText>

        <FadeUpText className="block w-full mb-6 [animation-delay:0.08s]">
          <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-950 dark:text-white leading-tight">
            Simple, transparent pricing.
            <br className="hidden sm:block" />
            <span className="bg-gradient-to-r from-blue-600 to-cyan-600 dark:from-blue-400 dark:to-cyan-400 bg-clip-text text-transparent">
              Start free for 14 days.
            </span>
          </h1>
        </FadeUpText>

        <FadeUpText className="block w-full mb-10 [animation-delay:0.16s]">
          <p className="text-lg text-gray-600 dark:text-slate-400 leading-relaxed max-w-xl mx-auto">
            Choose the plan that fits where you are today. WealthScope to understand your financial readiness, PortfolioIQ to analyze your investments, or both together with the Bundle.
          </p>
        </FadeUpText>

        <FadeUpText className="block w-full [animation-delay:0.24s]">
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-gray-600 dark:text-slate-400">
            {[
              "14-day free trial",
              "We'll remind you before you're charged",
              "Cancel anytime",
              "17% off annual plans",
            ].map((item) => (
              <span key={item} className="flex items-center gap-1.5">
                <Check className="w-3.5 h-3.5 text-blue-700 dark:text-blue-400 shrink-0" />
                {item}
              </span>
            ))}
          </div>
        </FadeUpText>
      </div>
    </section>
  );
};
